import React from 'react'
import { useState } from 'react'
import { Input, Button, Checkbox } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'
import { formatPrice, formatPerc } from '../common/utils'
import { getViewPdfLink } from '../services/api'
import { anySalesTax, calculateSalesTax, calculateSelectedTotal, updateProgressBasedPaymentAmounts } from '../helpers/proposal'

const ApprovalAndPayment = ({lineItems, paymentSchedule, showPdfLink, isPreview, onSubmit, isSubmitting}) => {
  const [showError, setShowError] = useState(false)
  const [isApproved, setIsApproved] = useState(false)
  const [approvedBy, setApprovedBy] = useState('')

  const handleConfirm = () => {
    if (!isApproved || !approvedBy) {
      setShowError(true)
      return
    }

    onSubmit(approvedBy)
  }

  const totalPriceWithoutSalesTax = calculateSelectedTotal(lineItems)
  const salesTax = calculateSalesTax(lineItems)
  const showSalesTax = anySalesTax(lineItems)
  const totalPriceWithSalesTax = totalPriceWithoutSalesTax + salesTax
  const updatedPaymentSchedules = updateProgressBasedPaymentAmounts(lineItems, paymentSchedule, totalPriceWithoutSalesTax)

  return <div className="clearfix">
  <div className="signoff clearfix">
    <div>
      <Checkbox
        checked={isApproved}
        onChange={x => {
          setIsApproved(x.target.checked)
          setShowError(false)
        }}
      >
        I consent to electronic approval of the selected workareas
      </Checkbox>
      <div className="signature">{approvedBy}</div>
      <Input
        value={approvedBy}
        onChange={x => {
          setApprovedBy(x.target.value)
          setShowError(false)
        }}
        placeholder="Sign your name"
      />
      {showError && <div className="validation-error">Please consent to electronic approvals and sign before submitting</div>}
    </div>
  </div>
  <div className="totals">
    <table className="pricing-table">
      <tbody>
        {updatedPaymentSchedules.map((x, i) => <tr key={i}>
          <td className="soft">{x.note}</td>
          <td>{x.title}</td>
          <td className="price">{formatPrice(x.amount)} ({formatPerc(x.percentage)}%)</td>
        </tr>)
        }
        {showSalesTax && <>
          <tr>
            <td></td>
            <td className="subtotal">Subtotal</td>
            <td className="price subtotal">{formatPrice(totalPriceWithoutSalesTax)}</td>
          </tr>
          <tr>
            <td></td>
            <td>Estimated Sales Tax</td>
            <td className="price">{formatPrice(salesTax)}</td>
          </tr>
        </>
        }
        <tr>
          <td></td>
          <td><h3 className="total-price">Total</h3></td>
          <td className="price"><h3 className="total-price">{formatPrice(totalPriceWithSalesTax)}</h3></td>
        </tr>
      </tbody>
    </table>

    {!showSalesTax &&
      <div className="sales-tax-not-applicable">* Sales tax, if applicable, is not represented on this proposal</div>
    }

    <Button
      type="primary"
      htmlType="submit"
      className="submit-btn"
      onClick={handleConfirm}
      loading={isSubmitting}
      disabled={isPreview}
      title={isPreview && 'Proposal cannot be approved in preview mode'}
    >
      Confirm
    </Button>

    {showPdfLink &&
      <div style={{ marginTop: 32 }}>
        <Button icon={<DownloadOutlined />} type="link" href={getViewPdfLink(isPreview)} target="_blank" rel="noopener nofollower">Download a PDF of this proposal</Button>
      </div>
    }

  </div>
</div>
}

export default ApprovalAndPayment